import { type EnvironmentId, type ProjectId } from "@t3tools/contracts";
import { FilesIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "../ui/button";
import { useDocumentsPanelStore } from "../../documentsPanelStore";

export function DocumentsHeaderButton({
  environmentId,
  projectId,
  projectCwd,
}: {
  environmentId: EnvironmentId;
  projectId: ProjectId;
  projectCwd: string;
}) {
  const { t } = useTranslation();
  const openPanel = useDocumentsPanelStore((state) => state.openPanel);
  return (
    <Button
      variant="outline"
      size="xs"
      className="shrink-0 gap-1"
      onClick={() => openPanel({ environmentId, projectId, projectCwd })}
    >
      <FilesIcon className="size-3" />
      {t("common/documents_y9a1to")}
    </Button>
  );
}
